import * as React from 'react';

import styles from './animate-success.module.css';

type Props = {
    children: React.ReactNode;
    active: boolean;
};

export function AnimateSuccess(props: Props) {
    return (
        <div
            className={props.active ? styles['animate-success--active'] : styles['animate-success']}
        >
            {props.children}
        </div>
    );
}
